(ns ui.modals.entity-selector.view
  (:require [clojure.string :as string]
            [common.entity :as c-entity]
            [common.localization :as loc]
            [common.schema.registry :as registry]
            [frontend.view.entity :as f-entity]
            [reagent.core :as r]
            [ui.components.modal.style :as modal-style]
            [ui.components.modal.view :as modal]
            [ui.editors.labelled-input.view :as labelled-input]))

(defn open-and-select!
  "Open the shared entity creator and return the created entity as a picker option."
  [entity-types {:keys [on-select!] :as args}]
  (f-entity/open-creator!
   entity-types
   (-> args
       (dissoc :on-select!)
       (assoc :on-ok!
              (fn [{:keys [new-entity-id new-entity close-cb!]}]
                (when (fn? on-select!)
                  (on-select! new-entity-id
                              {:value new-entity-id
                               :label (c-entity/display-string new-entity)}))
                (when (fn? close-cb!)
                  (close-cb!)))))))

(defn body
  [{:keys [local-state* label entity-types new-entity-start-value named-value-attribute on-select!]}]
  [:div
   [labelled-input/view
    {:editor-type           :editor.type/search
     :graph-entity-id 1321
     :named-value-attribute named-value-attribute
     :field/entity-types    entity-types
     :create!               (fn [input-str]
                              (let [name-attribute (->> entity-types
                                                        (keep registry/resolve-name-attribute)
                                                        (first))]
                                (swap! local-state* assoc :visible? false)
                                (open-and-select!
                                 entity-types
                                 {:start-value           (cond (and name-attribute new-entity-start-value)
                                                               (assoc new-entity-start-value name-attribute input-str)
                                                               new-entity-start-value
                                                               new-entity-start-value
                                                               :else
                                                               input-str)
                                  :named-value-attribute named-value-attribute
                                  :skip-success-msg?     true
                                  :on-cancel!            (fn [_]
                                                           (swap! local-state* assoc :visible? true))
                                  :on-select!            on-select!})))
     :value                 (:value-opt @local-state*)
     :label                 label
     :on-change             (fn [selected-value selected-option]
                              (swap! local-state* assoc :visible? false)
                              (on-select! selected-value selected-option))}]])

(defn view
  [{:keys [_title _entity-types _new-entity-start-value _label _on-select! _on-cancel!]}]
  (let [local-state* (r/atom {:visible? true})]
    (fn [{:keys [entity-types title on-cancel!] :as args}]
      [modal/view
       {:visible? (:visible? @local-state*)
        :size     modal-style/size-md
        :hide!    (fn [_]
                    (swap! local-state* assoc :visible? false)
                    (on-cancel!))}
       (or title
           (if (= 1 (count entity-types))
             (loc/tr :select-entity-of-type [(loc/tr (first entity-types))])
             (loc/tr :select-entity-of-types [(string/join ", " (map loc/tr entity-types))])))
       [body (assoc args :local-state* local-state*)]
       nil])))
